<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/mis/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let score = {"4-11":"4-11","12-24":"12-24","25-37":"25-37","38-56":"38-56"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete"){
          this.dataChanage(URL.appRiskArticle.del,{id:row.id},res => {
            this.$refs.childTable.defaultQueryData(this.queryData);
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.appRiskArticle.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error("suc");
          }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: '主键', field: 'id',hidden:true},
            { title: '分数', field: 'score',type:2,optionList:score,required:true},
            { title: '文章', field: 'article',type: 14,required:true},
            { title: '文章(英文)', field: 'articleEn',type: 14,required:true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            {click:"查询"},
            {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.appRiskArticle.query, //请求路径和参数
          sequence: true,
          cols: [
            { title: '分数', field: 'score'},
            { title: '发布时间', field: 'updateTime', render: (data, full) => {
                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
              }},
            {title:"操作", btnClick: [
              { name: "修改", size: 'mini', click: 'update', type: 'primary' ,icon:"el-icon-update"},
              { name: "删除", size: 'mini', click: 'delete', type: 'primary' ,icon:"el-icon-delete"}]
            }
          ]
        }
      }
    }
  }
</script>
